import React from 'react';
import { Link } from '../types';
import { StyledLink } from './styles';
import { fontSize } from '../utils';
import { HelpTip } from '@amzn/storm-ui';

export const AttributesLink: React.VFC<Link> = ({
  id,
  label,
  url,
  openInNewTab,
  disabled,
  toolTip,
  tooltipPosition,
  ariaLabel,
}) => (
  <>
    <StyledLink
      id={id}
      href={disabled ? '' : url}
      disabled={disabled}
      external={openInNewTab}
      size={fontSize()}
      aria-label={ariaLabel}
    >
      {label}
    </StyledLink>
    {toolTip?.length && (
      <HelpTip
        tooltipProps={{
          withCloseButton: false,
          position: tooltipPosition,
          variant: disabled ? 'inverted' : 'default',
        }}
      >
        {toolTip}
      </HelpTip>
    )}
  </>
);
